<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import vuex from '../store';


    import magNav from './nav/index.vue';
    import magHeader from './header/index.vue';
    import magFooter from './footer/index.vue';
    import magLogin from './login/index.vue';
    import axios from "axios";

    export default {
        el: '#mag',
        props: {},
        data() {
            return {
                show: false,
            }
        },
        computed: {
            ...mapGetters({
                loading: 'user/loading',
            }),
            ...mapState('user', {
                auth: 'auth',
            }),
        },
        watch: {},
        mounted() {
            this.$store.dispatch('create');
            setTimeout(() => {
                this.show = true;
            }, 300)
            console.log(vuex);
        },
        components: {magNav, magHeader, magFooter, magLogin},
        created() {
            axios.get('/tourclient/settings/index')
                .then(({data}) => {
                    this.$store.dispatch('settings', data.MasterAgentSettings);
                }).catch()
        },
    }
</script>
<template>
    <div id="mag" class="mag" v-loading="loading" :class="{login: !auth}">
        <iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
        <div class="mag-container" v-if="show||!loading">
            <div class="mag-body">
                <router-view class="main-body" v-if="auth&&!loading"></router-view>
                <mag-login class="main-body" v-if="!auth"></mag-login>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    html,
    body,
    .mag {
        width: 100%;
        height: 100%;
        .b24-widget-button-wrapper {
            z-index: 1999;
        }
        .b24-widget-button-shadow.b24-widget-button-show {
            z-index: 1998;
        }
    }

    html body .b24-widget-button-position-bottom-left {
        left: 0;
        bottom: 0;
    }

    * {
        box-sizing: border-box;
    }

    body {
        font-family: 'Ubuntu', Arial, "Helvetica CY", "Nimbus Sans L", sans-serif;
        font-size: 12px;
        min-width: 1220px;
        .el-popper[x-placement^="bottom"] {
            margin-top: 6px;
        }
        .el-popper[x-placement^="top"] {
            margin-bottom: 6px;
        }
        .el-notification {
            z-index: 11000 !important;
        }
    }

    .mag-main{
        height: 100vh;
    }

    .mag {
        display: flex;
        &-nav {
            width: 180px;
            height: 100%;
        }
        &-container {
            height: 100%;
            width: 100%;
        }
        &-header {
            height: 40px;
            width: 100%;
        }
        &-body {
            height: 100%;
            width: 100%;
            overflow: auto;
        }
        &-footer {
            height: 50px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-weight: 300;
            text-align: center;
        }
    }
    .main-body {
        min-height: 100%;
    }

    .login {
        .mag {
            &-nav {
                width: 132px;
            }
            &-container {
                width: calc(100% - 132px);
            }
            &-header {
                height: 100px;
            }
            &-body {
                height: calc(100% - 100px);
            }
            &-footer {
                height: 60px;
            }
            &-main {
                height: calc(100% - 60px);
            }
        }
    }

    .el-loading-mask {
        background-color: #fff;
    }

    .wrap {
        width: 1040px;
        margin: auto;
    }

    /*












    */
    .el-table td .cell {
        text-overflow: ellipsis;
        white-space: normal;
        word-break: normal;
        line-height: 15px;
    }

    .el-table th > .cell {
        word-break: normal;
    }

    .mag {
        textarea {
            font: 400 12px Arial;
        }
    }

    .el-notification__content p {
        font-size: 13px;
        text-align: left;
    }

    .el-notification.right {
        right: 16px;
        margin-top: 32px;
        width: 300px;
    }

    footer {
        display: flex;
        height: 50px;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 300;
        background: #47634e;
        color: #fff;
    }
</style>
